import { render } from "./GatewayCountrol2.vue?vue&type=template&id=59fd2ac8&scoped=true"
import script from "./GatewayCountrol2.vue?vue&type=script&lang=js"
export * from "./GatewayCountrol2.vue?vue&type=script&lang=js"

import "./GatewayCountrol2.vue?vue&type=style&index=0&id=59fd2ac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fd2ac8"]])

export default __exports__